import { Fragment } from 'react';
import Tile, { type OwnProps as TileProps } from './Tile';
import { TilesWrapper } from './Tiles.styles';

type OwnProps = {
  tiles: TileProps[];
};

export default function Tiles(props: OwnProps) {
  return (
    <TilesWrapper>
      {props.tiles.map((tile, index) => (
        <Fragment key={index}>
          <Tile className="px-xl py-lg" {...tile} />

          {index < props.tiles.length - 1 && (
            <div className="mx-xl border border-border-inverse-transparent" />
          )}
        </Fragment>
      ))}
    </TilesWrapper>
  );
}
